(() => {
  const initTabs = (root = document) => {
    root.querySelectorAll('[data-bioyon-product-tabs]').forEach((tabs) => {
      if (tabs.dataset.bioyonTabsInitialized === 'true') return;
      tabs.dataset.bioyonTabsInitialized = 'true';

      const buttons = Array.from(tabs.querySelectorAll('[role="tab"][data-tab]'));
      const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"][data-panel]'));

      const activate = (button, focus = false) => {
        const target = button.dataset.tab;

        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active = panel.dataset.panel === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        if (focus) button.focus();
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          activate(buttons[nextIndex], true);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initTabs();
    });
  } else {
    initTabs();
  }

  document.addEventListener('shopify:section:load', (event) => initTabs(event.target));
})();

if (!customElements.get('bioyon-coa-status')) {
  customElements.define('bioyon-coa-status', class extends HTMLElement {
    connectedCallback() {
      this.onVariant = (event) => {
        const id = event.detail?.selected?.id;
        if (id) this.updateVariant(String(id));
      };
      document.addEventListener('product-variant-updated', this.onVariant);
      const summary = this.closest('.product-summary-inner');
      const id = summary?.querySelector('form[data-type="add-to-cart-form"] [name="id"]')?.value || this.dataset.selectedVariant;
      this.updateVariant(String(id));
    }
    disconnectedCallback() {
      document.removeEventListener('product-variant-updated', this.onVariant);
    }
    updateVariant(id) {
      const template = Array.from(this.querySelectorAll('template[data-coa-variant]')).find(item => item.dataset.coaVariant === id);
      const display = this.querySelector('[data-coa-display]');
      if (!template || !display) return;
      this.dataset.selectedVariant = id;
      display.replaceChildren(template.content.cloneNode(true));
      const label = this.closest('.product-summary-inner')?.querySelector('[data-coa-trust-label]');
      if (label) label.textContent = template.dataset.coaLabel;
    }
  });
}
